export var ActurisQuoteStatus;

(function (ActurisQuoteStatus) {
  ActurisQuoteStatus["OBTAINED"] = "Obtained";
  ActurisQuoteStatus["REFER_CONTINUE"] = "ReferContinue";
  ActurisQuoteStatus["REFERRED_TO_UW"] = "Referred";
  ActurisQuoteStatus["DECLINED"] = "Declined";
  ActurisQuoteStatus["ACCEPTED"] = "Accepted";
  ActurisQuoteStatus["NO_QUOTE"] = "No Quote";
})(ActurisQuoteStatus || (ActurisQuoteStatus = {}));